import { list } from './list';
import { quiz } from './quiz';
import { setStatus } from './set-status';

type ApiDeclaration = {
    quiz: typeof quiz;
    list: typeof list;
    setStatus: typeof setStatus;
};

export const contentReviewsApiDeclaration: ApiDeclaration = {
    quiz,
    list,
    setStatus,
};
